import { put, call, takeLatest } from 'redux-saga/effects';
import {
    Actions,
    getLayoutsSuccess, getLayoutsFailure,
} from 'actions/layoutActions';
import { apiGet } from './apiSagas';
import { Layout } from 'shared/models';
import { toError } from 'shared/util/toError';

export function* getLayoutsSaga() {
    yield takeLatest(Actions.GET_LAYOUTS_REQUEST, function* getLayouts() {
        try {
            const layouts: readonly Layout[] = yield call(apiGet, '/api/layouts');
            yield put(getLayoutsSuccess(layouts));
        }
        catch (e) {
            const err = toError(e);
            yield put(getLayoutsFailure(err));
        }
    });
}
